import moment from 'moment';
import logo from "../../images/logo_t.svg";

// YEARS STARTING FROM 1901
export const YEARS = Array.from({ length: moment().year() - 1900 }, (_, i) => i + 1901);

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const STATES = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District Of Columbia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];

export const GOOGLE_ADDRESS_TYPES = {
  STREET_NUMBER: "street_number",
  ROUTE: "route",
  POSTAL_CODE: "postal_code",
  LOCALITY: "locality",
  ADMINISTRATIVE_AREA_LEVEL_1: "administrative_area_level_1",
};

export const boostLookbackSelectionUrl = "/boost/upgrade-membership";

export const tomoCardBankListItem = {
  uuid: 'tomo-card-bank-list-fake-uuid',
  type: 'credit-card',
  institutionName: 'TomoCredit',
  logoURL: logo,
  mask: "Tomo",
  appliedProducts: ["credit_boost"],
};

export const boostTiers = {
  BASIC: "BASIC",
  PLUS: "PLUS",
  PREMIUM: "PREMIUM",
  VIP: "VIP",
};

export const BOOST_SUBSCRIPTION_FEATURES = {
  BILLS_HISTORY: "BILLS_HISTORY",
  CREDIT_WITH_BILL_HISTORY: "CREDIT_WITH_BILL_HISTORY",
  LIVE_CREDIT_MONITORING: "LIVE_CREDIT_MONITORING",
  REPORT_THIRD_PARTY: "REPORT_THIRD_PARTY",
  CREDIT_REPORTING: "CREDIT_REPORTING",
  HEALTH_CHECK: 'HEALTH_CHECK',
  PRIORITY_SUPPORT: 'PRIORITY_SUPPORT',
  CREDIT_COACHING: 'CREDIT_COACHING',
  EXCLUSIVE_OFFERS: 'EXCLUSIVE_OFFERS',
};

export const BOOST_SUBSCRIPTION_FEATURE_PERKS = {
  [BOOST_SUBSCRIPTION_FEATURES.BILLS_HISTORY]: "Matched bills history",
  [BOOST_SUBSCRIPTION_FEATURES.CREDIT_WITH_BILL_HISTORY]: "Analyze credit with past bills",
  [BOOST_SUBSCRIPTION_FEATURES.LIVE_CREDIT_MONITORING]: "Live Credit Monitoring",
  [BOOST_SUBSCRIPTION_FEATURES.REPORT_THIRD_PARTY]: "All major bureau support",
  [BOOST_SUBSCRIPTION_FEATURES.CREDIT_REPORTING]: "Expedited credit reporting",
  [BOOST_SUBSCRIPTION_FEATURES.HEALTH_CHECK]: 'Credit health checks',
  [BOOST_SUBSCRIPTION_FEATURES.PRIORITY_SUPPORT]: 'Priority support',
  [BOOST_SUBSCRIPTION_FEATURES.CREDIT_COACHING]: '1-on-1 credit coaching',
  [BOOST_SUBSCRIPTION_FEATURES.EXCLUSIVE_OFFERS]: 'Exclusive offers',
};

const BASIC_PLAN_FEATURES = [
  {
    title: BOOST_SUBSCRIPTION_FEATURES.BILLS_HISTORY,
    description: [
      {
        text: "up to ",
      },
      {
        text: "$1,000",
        style: { color: "#FFFFFF", fontWeight: 700 },
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_WITH_BILL_HISTORY,
    description: [
      {
        text: "2 months",
        style: { color: "#FFFFFF", fontWeight: 700 },
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.LIVE_CREDIT_MONITORING,
    description: [],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.REPORT_THIRD_PARTY,
    description: [],
  },
];

const BASIC_PLAN_FEATURES_MOBILE = [
  {
    title: BOOST_SUBSCRIPTION_FEATURES.BILLS_HISTORY,
    description: [
      {
        text: "Up to ",
      },
      {
        text: "$1k",
        style: { color: "#FFFFFF", fontWeight: 700 },
      },
      {
        text: "bill history",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_WITH_BILL_HISTORY,
    description: [
      {
        text: "2 months",
        style: { color: "#FFFFFF", fontWeight: 700 },
      },
      {
        text: "of bill tracking",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.LIVE_CREDIT_MONITORING,
    description: [
      {
        text: "Live Credit Monitoring",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.REPORT_THIRD_PARTY,
    description: [
      {
        text: "All major bureau support",
      },
    ],
  },
];

const PREMIUM_PLAN_FEATURES = [
  {
    title: BOOST_SUBSCRIPTION_FEATURES.BILLS_HISTORY,
    description: [
      {
        text: "up to ",
      },
      {
        text: "$20,000",
        style: { color: "#FFFFFF", fontWeight: 700 },
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_WITH_BILL_HISTORY,
    description: [
      {
        text: "12 months",
        style: { color: "#FFFFFF", fontWeight: 700 },
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.LIVE_CREDIT_MONITORING,
    description: [],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.REPORT_THIRD_PARTY,
    description: [],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_REPORTING,
    description: [],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.HEALTH_CHECK,
    description: [],
  },
];

const PREMIUM_PLAN_FEATURES_MOBILE = [
  {
    title: BOOST_SUBSCRIPTION_FEATURES.BILLS_HISTORY,
    description: [
      {
        text: "Up to ",
      },
      {
        text: "$20k",
        style: { color: "#FFFFFF", fontWeight: 700 },
      },
      {
        text: "bill history",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_WITH_BILL_HISTORY,
    description: [
      {
        text: "12 months",
        style: { color: "#FFFFFF", fontWeight: 700 },
      },
      {
        text: "of bill tracking",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.LIVE_CREDIT_MONITORING,
    description: [
      {
        text: "Live Credit Monitoring",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.REPORT_THIRD_PARTY,
    description: [
      {
        text: "All major bureau support",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.HEALTH_CHECK,
    description: [
      {
        text: "Credit health checks",
      },
    ],
  },
];

// TODO check features
const PLUS_PLAN_FEATURES = [
  {
    title: BOOST_SUBSCRIPTION_FEATURES.BILLS_HISTORY,
    description: [
      {
        text: "Up to ",
      },
      {
        text: "$5k",
        style: { color: "#FFFFFF", fontWeight: 700 },
      },
      {
        text: "bill history",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_WITH_BILL_HISTORY,
    description: [
      {
        text: "6 months",
        style: { color: "#FFFFFF", fontWeight: 700 },
      },
      {
        text: "of bill tracking",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.LIVE_CREDIT_MONITORING,
    description: [],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.REPORT_THIRD_PARTY,
    description: [],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_REPORTING,
    description: [],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.HEALTH_CHECK,
    description: [],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.PRIORITY_SUPPORT,
    description: [],
  },
];

const VIP_PLAN_FEATURES = [
  {
    title: BOOST_SUBSCRIPTION_FEATURES.BILLS_HISTORY,
    description: [
      {
        text: "up to ",
      },
      {
        text: "$30,000",
        style: { color: "#FFFFFF", fontWeight: 700 },
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_WITH_BILL_HISTORY,
    description: [
      {
        text: "24 months",
        style: { color: "#FFFFFF", fontWeight: 700 },
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.LIVE_CREDIT_MONITORING,
    description: [],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.REPORT_THIRD_PARTY,
    description: [],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_REPORTING,
    description: [],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.HEALTH_CHECK,
    description: [],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.PRIORITY_SUPPORT,
    description: [],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_COACHING,
    description: [],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.EXCLUSIVE_OFFERS,
    description: [],
  },
];

const VIP_PLAN_FEATURES_MOBILE = [
  {
    title: BOOST_SUBSCRIPTION_FEATURES.BILLS_HISTORY,
    description: [
      {
        text: "Up to ",
      },
      {
        text: "$30k",
        style: { color: "#FFFFFF", fontWeight: 700 },
      },
      {
        text: "bill history",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_WITH_BILL_HISTORY,
    description: [
      {
        text: "24 months",
        style: { color: "#FFFFFF", fontWeight: 700 },
      },
      {
        text: "of bill tracking",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.LIVE_CREDIT_MONITORING,
    description: [
      {
        text: "Live Credit Monitoring",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.REPORT_THIRD_PARTY,
    description: [
      {
        text: "All major bureau support",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.HEALTH_CHECK,
    description: [
      {
        text: "Credit health checks",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.PRIORITY_SUPPORT,
    description: [
      {
        text: "Priority support",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_COACHING,
    description: [
      {
        text: "1-on-1 credit coaching",
      },
    ],
  },
  {
    title: BOOST_SUBSCRIPTION_FEATURES.EXCLUSIVE_OFFERS,
    description: [
      {
        text: "Exclusive offers",
      },
    ],
  },
];

export const boostProductTierMonthlyConfig = {
  BASIC: {
    title: "🛰️ Basic Journey",
    name: "Basic",
    icon: "🛰️",
    price: Date.now() >= (new Date("2024-02-22T08:00:00.000Z")).getTime() ? 14.99 : 9.99,
    originalPrice: 19.99,
    billingPeriod: "Per month",
    maxLine: 1000,
    minLine: 500,
    lookbackPeriod: "2 months",
    perks: [
      "2 months of instant credit history reported.",
      "2 months of past bills added to your account.",
      "Up to $1000/per month reported as credit.*",
    ],
    features: BASIC_PLAN_FEATURES,
    featuresMobile: BASIC_PLAN_FEATURES_MOBILE,
  },
  PLUS: {
    title: "🌙 Plus Journey",
    name: "Plus",
    icon: "🌙",
    price: 29.99,
    originalPrice: 69.99,
    billingPeriod: "Per month",
    maxLine: 5000,
    minLine: 1000,
    lookbackPeriod: "6 months",
    perks: [
      "6 months of instant credit history reported.",
      "6 months of past bills added to your account.",
      "Up to $5000/per month reported as credit.*",
    ],
    features: PLUS_PLAN_FEATURES,
  },
  PREMIUM: {
    title: "🪐 Premium Journey",
    name: "Premium",
    icon: "🪐",
    price: Date.now() >= (new Date("2024-02-22T08:00:00.000Z")).getTime() ? 69.99 : 49.99,
    originalPrice: 99.99,
    billingPeriod: "Per month",
    maxLine: 20000,
    minLine: 5000,
    lookbackPeriod: "12 months",
    label: "Popular",
    perks: [
      "12 months of instant credit history reported.",
      "12 months of past bills added to your account.",
      "Up to $20,000/per month reported as credit.*",
    ],
    features: PREMIUM_PLAN_FEATURES,
    featuresMobile: PREMIUM_PLAN_FEATURES_MOBILE,
  },
  VIP: {
    title: "☀️ VIP Journey",
    name: "VIP",
    icon: "☀️",
    price: Date.now() >= (new Date("2024-02-22T08:00:00.000Z")).getTime() ? 129.99 : 99.99,
    originalPrice: 274.99,
    billingPeriod: "Per month",
    maxLine: 30000,
    minLine: 10000,
    lookbackPeriod: "24 months",
    label: "Best Value",
    perks: [
      "24 months of instant credit history reported.",
      "24 months of past bills added to your account.",
      "Up to $30,000/per month reported as credit.*",
    ],
    features: VIP_PLAN_FEATURES,
    featuresMobile: VIP_PLAN_FEATURES_MOBILE,
  },
};

export const boostProductTierYearlyConfig = {
  BASIC: {
    title: "🛰️ Basic Journey",
    name: "Basic",
    icon: "🛰️",
    price: 99.99,
    originalPrice: 19.99 * 12,
    billingPeriod: "Per year",
    maxLine: 1000,
    minLine: 500,
    lookbackPeriod: "2 months",
    perks: [
      "2 months of instant credit history reported.",
      "2 months of past bills added to your account.",
      "Up to $1000/per month reported as credit.*",
    ],
    features: BASIC_PLAN_FEATURES,
    featuresMobile: BASIC_PLAN_FEATURES_MOBILE,
  },
  PLUS: {
    title: "🌙 Plus Journey",
    name: "Plus",
    icon: "🌙",
    price: 249.99,
    originalPrice: 69.99 * 12,
    billingPeriod: "Per year",
    maxLine: 5000,
    minLine: 1000,
    lookbackPeriod: "6 months",
    perks: [
      "6 months of instant credit history reported.",
      "6 months of past bills added to your account.",
      "Up to $5000/per month reported as credit.*",
    ],
    features: PLUS_PLAN_FEATURES,
  },
  PREMIUM: {
    title: "🪐 Premium Journey",
    name: "Premium",
    icon: "🪐",
    price: 399.99,
    originalPrice: 99.99 * 12,
    billingPeriod: "Per year",
    maxLine: 20000,
    minLine: 5000,
    lookbackPeriod: "12 months",
    label: "Popular",
    perks: [
      "12 months of instant credit history reported.",
      "12 months of past bills added to your account.",
      "Up to $20,000/per month reported as credit.*",
    ],
    features: PREMIUM_PLAN_FEATURES,
    featuresMobile: PREMIUM_PLAN_FEATURES_MOBILE,
  },
  VIP: {
    title: "☀️ VIP Journey",
    name: "VIP",
    icon: "☀️",
    price: 999.99,
    originalPrice: 274.99 * 12,
    billingPeriod: "Per year",
    maxLine: 30000,
    minLine: 10000,
    lookbackPeriod: "24 months",
    label: "Best Value",
    perks: [
      "24 months of instant credit history reported.",
      "24 months of past bills added to your account.",
      "Up to $30,000/per month reported as credit.*",
    ],
    features: VIP_PLAN_FEATURES,
    featuresMobile: VIP_PLAN_FEATURES_MOBILE,
  },
};

export const boostProductTierConfig = {
  monthly: boostProductTierMonthlyConfig,
  yearly: boostProductTierYearlyConfig,
};

export const BOOST_TERMS_AND_CONDITIONS_URL = "https://tomo-public-docs.s3.us-west-1.amazonaws.com/Terms+and+Conditions.pdf";